// removed by extract-text-webpack-plugin
module.exports = {"container":"_2j7iIZ0gvYSXgzfW249v9y","firstDiv":"_1t4TZheHsc7rSHayA8ITso","img":"_1lbD9HRr40ed40Abdh1NNj","title":"_3ek_YcvJN7Nz8Nwead0Yoi","secondDiv":"_6cJB1sBn-yflJSDtb4-fg","leftArrow":"_1p6ZzWDXZQAfrwDTZVftQv","arrowForward":"_3faUjGD-t8MJrUdqLz8xVW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Payment/CardItem.scss
// module id = 1147
// module chunks = 0